import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FlexView from 'react-flexview/lib';

import * as actions from '../../store/actions/churgerBuilderActions';

import ChatMessage from './ChatMessage';

export default function ChatRoom() {
	const dummy = useRef(null);
	const dispatch = useDispatch();
	const [formValue, setFormValue] = useState('');

	const msgs = useSelector((state) => {
		return state.messages;
	});

	const sendMessage = async (e) => {
		e.preventDefault();

		dispatch(actions.setMessages('sent', formValue));
		setFormValue('');

		setTimeout(function () {
			fetch(
				`https://www.personalityforge.com/api/chat/?apiKey=c9WBzkMgcNHllcxU&chatBotID=148149&message=${formValue}&externalID=69&firstName=Valued_Customer`
			)
				.then((res) => res.json())
				.then((data) => {
					dispatch(actions.setMessages('received', data.message.message));
					dispatch(actions.setFXPlaying('catBell'));
					dummy.current.scrollIntoView({ behavior: 'smooth' });
				})
				.catch((error) =>
					alert(
						`Ice cream machine bronk. Someone call the code jockey!!! ${error}`
					)
				);

			dummy.current.scrollIntoView({ behavior: 'smooth' });
		}, 1500);
	};

	return (
		<FlexView column hAlignContent="center">
			<FlexView column width="1080px" className="ChatMain">
				{msgs &&
					msgs.map((msg, index) => (
						<ChatMessage
							key={index}
							direction={msg.direction}
							text={msg.text}
						/>
					))}
				<span ref={dummy}></span>
			</FlexView>

			<form onSubmit={sendMessage}>
				<input
					value={formValue}
					onChange={(e) => setFormValue(e.target.value)}
					placeholder="be gentle. ^=w=^"
					maxLength="480"
				/>
				<button type="submit" disabled={!formValue} className="btn">
					Send
				</button>
			</form>
		</FlexView>
	);
}
